import styled from "styled-components";

const Texto = styled.div`
  color: ${(props) => props.theme.colors.tertiary};
  text-align: center;
  margin: 6rem 0;
  font-size: 14px;
`;

const Periodicidade = styled.div`
  color: ${(props) => props.theme.colors.tertiary};
  text-align: center;
  margin-bottom: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 50px;
  padding: 0.5rem;
  width: fit-content;
  margin: 0 auto 5rem;

  .opcao {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1.5rem;
    border-radius: 50px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    gap: 2rem;
    min-height: 35px;

    &.selecionado {
      background-color: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.white};

      span{
        background-color: ${({ theme }) =>
    theme.mode === 'light'
      ? '#2A844E'
      : '#2A844E'};
        padding: 1rem;
        border-radius: 50px;
        font-weight: 400;
        color: ${(props) => props.theme.colors.white};
      }
    }

    &:not(.selecionado) {
      color: ${(props) => props.theme.colors.text};

      span{
        background-color: ${({ theme }) =>
    theme.mode === 'light'
      ? '#EAEAEA'
      : '#626262'};
        color: ${({ theme }) =>
    theme.mode === 'light'
      ? '#626262'
      : '#EAEAEA'};
        padding: 1rem;
        border-radius: 50px;
        font-weight: 400;
      }
    }
  }
`;

const ComparativoPermissoes = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    thead {
      .cabecalho-planos{
        align-items: center;

        .recursos{
          font-weight: 900;
          color: ${(props) => props.theme.colors.primary};
        }

        th{
          text-align: center;
          padding: 5rem 9rem 3rem;
          position: relative;

          &.plano-atual-col {
            /* border: 3px solid ${(props) => props.theme.colors.primary};
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); */
            border-bottom: 0;
            
            &::after {
              content: "";
              position: absolute;
              top: 100%;
              left: 0;
              width: 100%;
              height: 100vh;
              background-color: rgba(42, 132, 78, 0.05);
              z-index: 0;
              pointer-events: none;
            }
          }

          .plano-atual{
            position: relative;
            border-radius: 1rem;
            padding: 2rem;
            transform: translateY(-10px) scale(1.05);
            z-index: 2;
            background: ${(props) => props.theme.colors.background};
            
            &:before {
              content: "Seu plano atual";
              position: absolute;
              top: -25px;
              left: 50%;
              transform: translateX(-50%);
              background-color: ${(props) => props.theme.colors.primary};
              color: white;
              padding: 0.5rem 2rem;
              border-radius: 2rem;
              font-weight: bold;
              white-space: nowrap;
              font-size: 12px;
            }

            button {
              background-color: ${(props) => props.theme.colors.primary};
              transition: all 0.3s ease;
              
              &:hover {
                background-color: ${(props) => props.theme.colors.tertiary};
                transform: translateY(-3px);
              }
            }
          }

          .titulo{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            .nome{
              font-weight: 900;
              color: ${(props) => props.theme.colors.primary};
            }

            .desconto{
              background-color: ${({ theme }) =>
                theme.mode === 'light'
                ? '#2A844E'
                : theme.colors.primary};
              padding: 1rem 2rem;
              border-radius: 50px;
              font-weight: 400;
              color: ${(props) => props.theme.colors.white};
            }
          }

          .descricao{
            font-weight: 400;
            color: ${(props) => props.theme.colors.tertiary};
            padding-bottom: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
              max-width: 60rem;
            }
          }

          .valor-riscado{
            font-weight: 400;
            color: ${(props) => props.theme.colors.tertiary};
            text-decoration: line-through;
          }

          .valor{
            color: ${(props) => props.theme.colors.primary};

            span{
              font-weight: 900;
            }
          }

          .equivalente{
            font-weight: 400;
            color: ${(props) => props.theme.colors.tertiary};
            padding-bottom: 2rem;
          }
        }
      }
    }

    tbody{
      .secao {
        background-color: #e8f5e9;
        font-family: 'Inter';
        font-weight: 700;
        color: ${(props) => props.theme.colors.primary};
        text-align: left;
        position: relative;
        z-index: 1;
    
        td {
          padding: 2.4rem 5rem;
        }
      }

      td {
        padding: 2.4rem 0 2.4rem 5rem;
        border-bottom: 1px solid #ddd;
        position: relative;
        z-index: 1;
      }

      .recurso{
        text-align: left;
        color: ${(props) => props.theme.colors.tertiary};
      }

      .informacao{
        text-align: center;
        color: ${(props) => props.theme.colors.tertiary};
      }

      .plano-atual-cell {
        background-color: rgba(42, 132, 78, 0.05);
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 3px;
          height: 100%;
          background-color: ${(props) => props.theme.colors.primary};
        }
        
        &::after {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 3px;
          height: 100%;
          background-color: ${(props) => props.theme.colors.primary};
        }
      }
    }
  }
`;

const ComparativoPermissoesMobile = styled.div`
  .plano-atual {
    flex: 1;

    .cabecalho {
      text-align: center;
      display: flex;
      padding: 5rem;

      .seta-esquerda,
      .seta-direita {
        background: none;
        border: none;
        cursor: pointer;

        svg{
          fill: ${({ theme }) =>
    theme.mode === 'light'
      ? '#2A844E'
      : theme.colors.primary};
        }
      }

      .informacoes-plano{
        position: relative;
        
        &.seu-plano-atual {
          /* border: 3px solid ${(props) => props.theme.colors.primary}; */
          /* border-radius: 1rem; */
          padding: 2rem;
          /* box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); */
          
          &:before {
            content: "Seu plano atual";
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
            background-color: ${(props) => props.theme.colors.primary};
            color: white;
            padding: 0.5rem 2rem;
            border-radius: 2rem;
            font-weight: bold;
            white-space: nowrap;
          }
          
        }
        
        .titulo{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            .nome{
              font-family: 'Inter';
              font-weight: 700;
              color: ${(props) => props.theme.colors.primary};
            }

            .desconto{
              background-color: ${({ theme }) =>
                theme.mode === 'light'
                ? '#2A844E'
                : theme.colors.primary};
              padding: 1rem 2rem;
              border-radius: 50px;
              font-weight: 400;
              color: ${(props) => props.theme.colors.white};
            }
          }

          .descricao{
            font-weight: 400;
            color: ${(props) => props.theme.colors.tertiary};
            padding-bottom: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
              max-width: 60rem;
            }
          }

          .valor-riscado{
            font-weight: 400;
            color: ${(props) => props.theme.colors.tertiary};
            text-decoration: line-through;
          }

          .valor{
            color: ${(props) => props.theme.colors.primary};

            > span{
              font-weight: 900;
            }
          }

          .equivalente{
            font-weight: 400;
            color: ${(props) => props.theme.colors.tertiary};
          }
      }
    }

    .secao-permissoes{
      &.seu-plano-atual {
        border-left: 3px solid ${(props) => props.theme.colors.primary};
        border-right: 3px solid ${(props) => props.theme.colors.primary};
        background-color: rgba(42, 132, 78, 0.05);
      }

      .titulo-secao {
        background-color: #e8f5e9;
        font-family: 'Inter';
        font-weight: 700;
        color: ${(props) => props.theme.colors.primary};
        text-align: left;
        padding: 2rem 5rem;
      }

      .lista-permissoes {
        display: flex;
        justify-content: space-between;
        padding: 2rem 5rem;
        border-bottom: 1px solid #ddd;
        color: ${(props) => props.theme.colors.tertiary};

        .titulo {
          color: ${(props) => props.theme.colors.tertiary};
        }

        .informacao {
          color: ${(props) => props.theme.colors.tertiary};
        }
      }
    }
  }
`;

const ScrollToTopButton = styled.button`
  position: fixed;
  bottom: 10rem;
  right: 5rem;
  width: 50px;
  height: 50px;
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 1000;
  transition: background-color 0.3s;

  svg {
    width: 24px;
    height: 24px;

    fill: ${(props) => props.theme.colors.white};
  }
`;

export {
  Texto,
  Periodicidade,
  ComparativoPermissoes,
  ComparativoPermissoesMobile,
  ScrollToTopButton,
};